/**
 * 关闭当前窗口
 */
export function closeWindows() {
  const userAgent = navigator.userAgent;
  // console.log("closeWindows", window);

  if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
    window.location.href = "about:blank";
  } else {
    window.opener = null;
    window.open("", "_self");
  }

  window.__close();
  top.__close();
}
